import React from 'react'
import logo1 from './Images/1.svg'
import logo2 from './Images/2.svg'
import logo3 from './Images/3.svg'
import logo4 from './Images/4.svg'
import logo5 from './Images/5.svg'
import logo6 from './Images/6.svg'
import { Link } from 'react-router-dom'

function JobsListing() {

    const jobs = [
        {
            title: 'Property Agent For UK Office Required',
            date: 'August 29, 2019',
            logo: logo1
        },
        {
            title: 'Property Agent For UK Office Required',
            date: 'August 29, 2019',
            logo: logo2
        },
        {
            title: 'Property Agent For UK Office Required',
            date: 'August 29, 2019',
            logo: logo3
        },
        {
            title: 'Property Agent For UK Office Required',
            date: 'August 29, 2019',
            logo: logo4
        },
        {
            title: 'Property Agent For UK Office Required',
            date: 'August 29, 2019',
            logo: logo5
        },
        {
            title: 'Property Agent For UK Office Required',
            date: 'August 29, 2019',
            logo: logo6
        },
    ]

    return (
        <>
            {jobs.map((job, index) => (
                <div className="single-job-list media" key={index}>
                    <img src={job.logo} alt="icon" />
                    <div className="media-body">
                        <h6>{job.title}</h6>
                        <span>{job.date}</span>
                    </div>
                    <Link to={'/Career/job-apply'} className="job-apply-btn align-self-center float-right">Apply Now</Link>
                </div>
            ))}
        </>
    )
}

export default JobsListing